import { render, staticRenderFns } from "./VStakeholderTab.vue?vue&type=template&id=89999952&"
import script from "./VStakeholderTab.vue?vue&type=script&lang=js&"
export * from "./VStakeholderTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports